import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-production-viewI';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { KanbanProductionMachineDialogComponent } from '../kanban-production-machine-dialog/kanban-production-machine-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { KanbanAddEditSwimLaneComponent } from '../kanban-add-edit-swimlane/kanban-add-edit-swimlane.component';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'anterasoftware-kanban-production-view',
  templateUrl: './kanban-production-view.component.html',
  styleUrls: ['./kanban-production-view.component.scss']
})
export class KanbanProductionViewComponent implements OnInit {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public statusList: any[] = [];
  @Output() public onDropJob: EventEmitter<any> = new EventEmitter();
  @Output() public editCard: EventEmitter<any> = new EventEmitter();
  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onPin: EventEmitter<any> = new EventEmitter();
  @Output() public onSwimLaneChange: EventEmitter<any> = new EventEmitter();
  @Output() public onDeleteSwimLane: EventEmitter<any> = new EventEmitter();
  public colorWarn = 'warn';
  public modeWarn = 'determinate';
  public valueWarn = 65;
  public bufferValueWarn = 85;
  
  public color = 'success';
  public mode = 'determinate';
  public value = 50;
  public bufferValue = 75;
  @Input() public defaultImg: string = '';
  @Input() public dateFormatString: string = 'DD/MM/YYYY';
  @Input() public timeFormatString: string = 'hh:mm a';

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  drop(event: any,swimLane:KanbanViewListI) {
    /* if(swimLane && swimLane.header && swimLane.header.title === 'Unscheduled Jobs') {
      let jobId = "";
        if(event.item && event.item.data) {
          jobId =  event.item.data.id
          
        }
        let job = {
          jobId: jobId,
          formValues: {
            machineId: "",
            scheduleDate: "",
          }
        }
      this.onUpdateJob.emit(job)
    } else {
        let dialogRef = this.dialog.open(KanbanProductionMachineDialogComponent, {
        width: '400px',
        height: '350px',
        data: {
          equipments: this.statusList,
          machineId: event.item.data.machineId
        },
      });

      dialogRef.afterClosed().subscribe((formValues: any) => {
        let jobId = "";
        if(event.item && event.item.data) {
          jobId =  event.item.data.id
          
        }
        if(formValues &&  formValues.machineId !="") {
          let job = {
            jobId: jobId,
            machineId: formValues.machineId,
            scheduleDate: swimLane.header.scheduleDate
          }
          this.onUpdateJob.emit(job)
        }
      });
    } */
    if(event && event.value) {
      let job = {
        production: event.value,
        status: swimLane,
      }
      this.onDropJob.emit(job);
    }
  }

  editCardDetails(card: any) {
    this.editCard.emit(card);
  }

  public cardValueChange(card: KanbanViewCardI, swimLaneIndex: number, cardIndex: number){
    // don't need this ngModel handles
    // this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    //this.onSwimLaneChange.emit(this.swimLaneList);
    this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    this.selectClicked.emit(this.swimLaneList);
  }

  pinned(cardDetails: any) {
    this.onPin.emit(cardDetails);
  }

  public openSwimLaneDialog(panel?: KanbanViewListI) {
    let dialogRef = this.dialog.open(KanbanAddEditSwimLaneComponent, {
      width: '500px',
      height: '450px',
      panelClass: 'antera-details-dialog',
      data: {
        panel: panel,
        swimlaneLength: this.swimLaneList.length
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {

      if (formValues) {
        this.onSwimLaneChange.emit(formValues);
      }
    });
  }

  public deleteSwimLane(swimlane?: KanbanViewListI) {
    this.onDeleteSwimLane.emit(swimlane);
  }

  public onToggleAll(event: MatCheckbox, swimLaneIndex: number){
    this.swimLaneList[swimLaneIndex]?.cards.forEach((card: KanbanViewCardI) => card.select = event.checked);
    this.selectClicked.emit(this.swimLaneList);
  }
}
